import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnAmberAlertPersonType } from './amber-alert-person-type';

export class SnAmberAlert extends SnModel {
  @Expose()
  public amberId: number;

  @Expose()
  public circumstances: string;

  @Expose()
  public contactOrg: string;

  @Expose()
  public contactPhone: string;

  @Expose()
  public isOpen: boolean;

  @Expose()
  public isPreview: boolean;

  @Expose()
  public lastSeenCity: string;

  @Expose()
  public lastSeenDate: string;

  @Expose()
  public lastSeenState: string;

  @Expose()
  public messageList: any[];

  @Expose()
  public missingDate: string;

  @Expose()
  public missingFrom: string;

  @Expose()
  public orgName: string;

  @Expose()
  public personList: SnAmberAlertPersonType[];

  @Expose()
  public targetList: any[];

  @Expose()
  public timeZone: string;

  @Expose()
  public vehicleList: any[];
}
